/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindTraceabilityRequestsForSupplierQueryResponse,
  FindTraceabilityRequestsForSupplierQueryParams,
} from "../types/FindTraceabilityRequestsForSupplier.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findTraceabilityRequestsForSupplierQueryKey = (
  params?: FindTraceabilityRequestsForSupplierQueryParams
) =>
  [{ url: "/v1/traceability-requests" }, ...(params ? [params] : [])] as const

export type FindTraceabilityRequestsForSupplierQueryKey = ReturnType<
  typeof findTraceabilityRequestsForSupplierQueryKey
>

/**
 * @summary Find traceability requests for supplier
 * {@link /v1/traceability-requests}
 */
export async function findTraceabilityRequestsForSupplier(
  params?: FindTraceabilityRequestsForSupplierQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindTraceabilityRequestsForSupplierQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/traceability-requests`,
    params,
    ...requestConfig,
  })
  return res
}

export function findTraceabilityRequestsForSupplierQueryOptions(
  params?: FindTraceabilityRequestsForSupplierQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findTraceabilityRequestsForSupplierQueryKey(params)
  return queryOptions<
    ResponseConfig<FindTraceabilityRequestsForSupplierQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindTraceabilityRequestsForSupplierQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findTraceabilityRequestsForSupplier(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find traceability requests for supplier
 * {@link /v1/traceability-requests}
 */
export function useFindTraceabilityRequestsForSupplier<
  TData = ResponseConfig<FindTraceabilityRequestsForSupplierQueryResponse>,
  TQueryData = ResponseConfig<FindTraceabilityRequestsForSupplierQueryResponse>,
  TQueryKey extends QueryKey = FindTraceabilityRequestsForSupplierQueryKey,
>(
  params?: FindTraceabilityRequestsForSupplierQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindTraceabilityRequestsForSupplierQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ??
    findTraceabilityRequestsForSupplierQueryKey(params)

  const query = useQuery(
    {
      ...findTraceabilityRequestsForSupplierQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
